module.exports = __webpack_public_path__ + "static/XTZCard-e9474b49b25a17910b1b832df2515c63.png";